import React from "react";
import Contact from "./components/Contact";

function App() {
  return (
    <div>
      <Contact />
    </div>
  );
}

export default App;
